import React from "react";
import styles from './skillsPage.module.less';

function SkillsPage(props)
{
    let i = 0;
    let content = Object.values(props.data).map(line=>{
        return (
            <div key={++i} className={styles.item}>
                <h3 className={styles.caption}>{line.title}</h3>
               {GetSkillsHtml(line.skills)}
            </div>
        );
    });
    return (
        <div className={styles.content}>
            {content}
        </div>
    );
}

export default SkillsPage;

function GetSkillsHtml(values)
{
    let skillsHTML = [];

    for(let i = 0; i < values.length;i++)
    {
        let cur = values[i];
        let innerItems = [];
        for(let j = 0; j < 10; j++)
        {
            if(j<cur.rate)
                innerItems.push(<li key={j} active=''></li>);
            else
                innerItems.push(<li key={j}></li>);

        }
        skillsHTML.push(
            <div key={i}>
                <h4>
                    {cur.title}
                </h4>
                <ul>
                    {innerItems}
                </ul>
            </div>
        )
    }

    return skillsHTML;
}